module.exports = __webpack_public_path__ + "img/img44.3175092a.png";